import {IPerson } from '../@types/Person';
import { useEffect,useState } from 'react';
import { useCopyToClipboard } from 'usehooks-ts'
import axios from "axios";
import '../personDetails.css';

type IProps = {
  person: IPerson;
  imgWidth: string,
  imgHeight: string,
};

const PersonDetailsComponent: React.FC<IProps> = ( props:IProps) => {
  
  const [faceImgWidth, setFaceImgWidth] = useState<string>(props.imgWidth);
  const [faceImgHeight, setFaceImgHeight] = useState<string>(props.imgHeight);
  const [currentPersonUrl, setPersonUrl] = useState('');
  const [personImages, setPersonImages] = useState<string[]>([]);
  const [personTags, setPersonTags] = useState<string[]>([]);
  const [currentThumbnailUrl, setProfilePicUrl] = useState('');
  const [lastSeenstr, seLastSeenstr] = useState('');
  const [siteICO, setSiteICO] = useState('');
  const [genderICO, setGenderICO] = useState('');

  useEffect(()=>{

    let width = document.documentElement.clientWidth;

    if(width<525){
      setFaceImgWidth("300");
      setFaceImgHeight("300");
    }

    seLastSeenstr(date_TO_String(new Date(props.person.lastSeen)));
    seLastSeenstr(props.person.lastSeenMsg);
    setProfilePicUrl(props.person.profilePicUrl);
    setPersonUrl(props.person.personUrl);
    setPersonImages(props.person.images);
    setPersonTags(props.person.tags);
    setSiteICO('images/' + props.person.siteCode + '.webp');
    setGenderICO('images/female.png');
}, []); // empty array means only once

  async function handleImageError(e:any){
    axios
    .get(props.person.profilePicUrl,{responseType:"blob",timeout: 5000})
    .then((resp) => {
      if(resp.data.type==='image/jpeg'){
        setProfilePicUrl(props.person.profilePicUrl);
        e.target.src = props.person.profilePicUrl;
      }else{
        setProfilePicUrl('images/unknown.gif');
        e.target.src = 'images/unknown.gif';
      }
    })
    .catch(() => {
      setProfilePicUrl('images/unknown.gif');
      console.clear();
    });
   }  

   function date_TO_String(date_Object: Date): string {
    let date_String: string =
      date_Object.getDate() +
      "/" +
      (date_Object.getMonth() + 1) +
      "/" +
      +date_Object.getFullYear();
    return date_String;
  }
  function openInNewTab(url:string){
    window.open(url, "_blank", "noreferrer");
  };
return (
  <div>
    <div className="results">
            <div className='thumb' role="link" onClick={() => openInNewTab(currentPersonUrl)} style={{cursor:'pointer'}}>
              <div className='thumbInner'>
              <div className={(props.person.isOnline ? 'onlineShow' : 'onlineHide')}>ONLINE</div>
                <img onError={(e) => handleImageError(e)} src={`${currentThumbnailUrl}`}  width={faceImgWidth} height={faceImgHeight} alt={`Click to visit camgirl ${props.person.name}`} title={`Click to visit camgirl ${props.person.name}`} />
              </div>     
            </div>
            <div>              
              <span>
                <img src={`${siteICO}`} alt={`${props.person.site}`} title={`${props.person.site}`}  width={16} height={16}/>
                &nbsp;&nbsp;<span onClick={() => openInNewTab(currentPersonUrl)} style={{cursor:'pointer'}} title={`Click to visit camgirl ${props.person.name}`} data-toggle="tooltip">{props.person.name}</span>&nbsp;
                <img src={genderICO} alt='Female' title='Female' width={16} height={16} style={{cursor:'pointer'}}/> 
                </span><br/>
              <span>Seen: {lastSeenstr}</span>
            </div>  
      <div>
      {personImages !== undefined && props.person.numberOfImages > 1 &&  personImages.map((imgData: string) => (
        <div key={imgData.substring(imgData.length-10, 10)} className='thumb' role="link" onClick={() => openInNewTab(currentPersonUrl)} style={{cursor:'pointer'}}>
          <div className='thumbInner'>
            <img src={`data:image/png;base64, ${imgData}`} />
          </div>     
        </div>
      ))         
      } 
      </div>
    </div>
    {personTags !== undefined && personTags.length > 0 &&  (
      <div style={{width:'100%',textAlign:'center'}}>
        <h5>Tags</h5>
        <div className='personTags'>
        {personTags.map((tag: string) => (
            <div className='tag' key={tag} >{tag}</div>
            ))         
        } 
        </div>
      </div>
      )} 
  </div>
  );
}
export default PersonDetailsComponent;